import { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const DISMISSED_KEY = 'stork:website-notice:v1';
const NOTICE_HOSTS = new Set([
    'tserentals.com',
    'www.tserentals.com',
    'test.tserentals.com',
    'localhost',
    '127.0.0.1',
]);

export function WebsiteNotice() {
    // Resolve on the client so prerendered HTML and hydration agree. The host
    // restriction also removes this old-site link after the storkrentals.ie cutover.
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!NOTICE_HOSTS.has(window.location.hostname)) return;
        try {
            setVisible(window.sessionStorage.getItem(DISMISSED_KEY) !== 'true');
        } catch {
            setVisible(true);
        }
    }, []);

    function dismiss() {
        setVisible(false);
        try {
            window.sessionStorage.setItem(DISMISSED_KEY, 'true');
        } catch {
            // Dismissal still works when browser storage is unavailable.
        }
    }

    if (!visible) return null;

    return (
        <aside aria-label="Website update" className="border-b border-primary/20 bg-primary/10 text-foreground">
            <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2 sm:px-6 lg:px-8">
                <p className="flex-1 text-sm leading-relaxed">
                    We’re working on our new website. You can also book on{' '}
                    <a
                        href="https://www.storkrentals.ie/"
                        className="font-semibold underline underline-offset-4 hover:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary"
                    >
                        our existing website
                    </a>.
                </p>
                <button
                    type="button"
                    onClick={dismiss}
                    aria-label="Dismiss website update"
                    className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full hover:bg-primary/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                >
                    <X size={18} aria-hidden="true" />
                </button>
            </div>
        </aside>
    );
}
